// Sale countdown: ticks every second and removes itself once the end time passes.
class SSaleTimer extends HTMLElement {
  connectedCallback() {
    this.end = Number(this.dataset.ends) * 1000;
    if (!this.end) return;
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const left = Math.floor((this.end - Date.now()) / 1000);
    if (left <= 0) {
      clearInterval(this.interval);
      this.hidden = true;
      return;
    }
    const parts = {
      d: Math.floor(left / 86400),
      h: Math.floor((left % 86400) / 3600),
      m: Math.floor((left % 3600) / 60),
      s: left % 60,
    };
    for (const [key, value] of Object.entries(parts)) {
      const el = this.querySelector(`[data-unit="${key}"]`);
      if (el) el.textContent = String(value).padStart(2, '0');
    }
  }
}

if (!customElements.get('s-sale-timer')) customElements.define('s-sale-timer', SSaleTimer);
